import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Button, Checkbox, Toggle } from "@ts-digital/vrc";
import { getBalanceRead } from "../../../../store/actions/reports/balance";
import { getEntriesRead } from "../../../../store/actions/reports/balance/ledger";
import { Select, AutoComplete } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import "./style.css";
import { VaporAccordion, VaporFormItem, VaporRangeDatePicker, VaporDatePicker } from "../../../vapor";
import {
  getVatSettlement,
  getWorkspaceSettlement,
  getVatSettlementRates
} from "../../../../store/actions/reports/vatSettlement";
import { demoCompanyCorrelations } from "../../correlations";
import AutocompleteSelector from "../../../general/autocompleteSelector/autocomplete";

const Option = Select.Option;

const useHeaderStatus = (config, paramsFromUrl) => {
  let initStatus = {};
  config.rows.forEach(r => {
    r.items.forEach(item => {
      if (item.id === "fromDate" || item.id === "toDate") {
        initStatus[item.id] = paramsFromUrl[item.id] ? moment(paramsFromUrl[item.id]) : item.initValue;
      } else {
        if (typeof (item.id) !== "object")
          initStatus[item.id] = paramsFromUrl[item.id] || item.initValue;
        else
          item.id.forEach((id, index) => {
            if (id === "fromDate" || id === "toDate") {
              initStatus[id] = paramsFromUrl[id] ? moment(paramsFromUrl[id]) : item.initValue[index];
            } else
              initStatus[id] = paramsFromUrl[id] || item.initValue[index];
          });
      }
    });
  });

  const [status, setStatus] = useState(initStatus);

  const modifyStatus = (
    id, value, saveAsObject = false
  ) => {
    setStatus(prevStatus => {
      const updatedStatus = { ...prevStatus };
      if (typeof (id) !== "object" || saveAsObject)
        updatedStatus[id] = value;
      else
        id.forEach((i, index) => updatedStatus[i] = value[index]);
      return updatedStatus;
    });
  };
  const resetHeaderStatus = () => {
    setStatus({});
  };

  const modelChanged = (config, paramsFromUrl) => {
    let initStatus = {};
    config.rows.forEach(r => {
      r.items.forEach(item => {
        if (item.id === "fromDate" || item.id === "toDate") {
          initStatus[item.id] = paramsFromUrl[item.id] ? moment(paramsFromUrl[item.id]) : item.initValue;
        } else {
          if (typeof (item.id) !== "object")
            initStatus[item.id] = paramsFromUrl[item.id] || item.initValue;
          else
            item.id.forEach((id, index) => {
              if (id === "fromDate" || id === "toDate") {
                initStatus[id] = paramsFromUrl[id] ? moment(paramsFromUrl[id]) : item.initValue[index];
              } else
                initStatus[id] = paramsFromUrl[id] || item.initValue[index];
            });
        }
      });
    });
    setStatus(initStatus);
  };

  return [status, modifyStatus, resetHeaderStatus, modelChanged];
};

const renderRange = (start, end) => {
  let items = [];
  if (start < end)
    for (let i = start; i <= end; i++) {
      items.push(<Option key={i} value={i}>
        {i}
      </Option>);
    }
  else
    for (let i = start; i >= end; i--) {
      items.push(<Option key={i} value={i}>
        {i}
      </Option>);
    }
  return items;
};

const renderValues = values => {
  let items = [];
  values.forEach((v, index) => {
    items.push(<Option key={index} value={v.value}>
      {v.label}
    </Option>);
  });
  return items;
};

const ReportCommonHeader = ({ setSelectedSearch, modelConfig,  paramsFromUrl }) => {
  const main = useSelector(state => state.main);
  const navigate = useNavigate();
  const reports = useSelector(state => state.reports);
  const [headerStatus, setHeaderStatus, resetHeaderStatus, modelChanged] = useHeaderStatus(modelConfig.header, paramsFromUrl);
  const dispatch = useDispatch();
  const [opened, setOpened] = useState(Object.keys(paramsFromUrl).length <= 1);
  const [currentValue, setCurrentValue] = useState(null);
  
  useEffect(() => {
    if (reports.search.status.ended) {
      setOpened(false);
    }
    if (Object.keys(headerStatus).length === Object.keys(paramsFromUrl).length && Object.keys(headerStatus).length > 0) {
      setOpened(false);
      getReport();
    }
  }, []);

  /**
  useEffect(() => {
    if (headerStatus.selectAccount && headerStatus.selectAccount.length === 0) {
      // Call API to get account list
      dispatch(searchAccounts("")).then(res => {
        const accounts = res.data.accounts.map(a => {
          return { value: a.title, label: a.title, code: a.code };
        });
        let title = "";
        if (headerStatus.accountId) {
          const findAccount = accounts.find(a => a.code === headerStatus.accountId);
          title = findAccount ? findAccount.title : "";
        }
        setHeaderStatus(["selectAccount", "accountTitle"], [accounts, title]);
      });
    }
  }, [headerStatus]);
   */

  useEffect(() => {
    modelChanged(modelConfig.header, paramsFromUrl);
    setOpened(Object.keys(paramsFromUrl).length <= 1);
  }, [modelConfig.id]);

  const getReport = () => {
    setSelectedSearch(true);
    setOpened(false);
    // TODO add dispatch to get reports
    if (modelConfig.id === "vatSettlement") {
      
      /** TODO chiamare api per recuperare l'id business. Per ora mocked */
      /** chiamare /api/v1/workspace/businesses
       * Ma ne potrebbe avere più di uno.
       *
       */
      dispatch(getVatSettlement(
        demoCompanyCorrelations?.[main.companyUuidSelected]?.businessVat,
        headerStatus.refYear,
        headerStatus.periodRef
      )).then(() => {
        dispatch(getWorkspaceSettlement(headerStatus.refYear,
          headerStatus.periodRef)).then(() => {
          dispatch(getVatSettlementRates()).then(() => {
            navigate({
              pathname: "/reports",
              search: `?model=vatSettlement&refYear=${headerStatus.refYear}&periodRef=${headerStatus.periodRef}`
            });
          });
        });
      });
     
    }
    if (modelConfig.id === "balance") {
      const fromDate = headerStatus.fromDate ? headerStatus.fromDate.format().substring(0, 10) : headerStatus.refYear + "-01-01";
      const toDate = headerStatus.fromDate ? headerStatus.toDate.format().substring(0, 10) : headerStatus.refYear + "-12-31";
      navigate({
        pathname: "/reports",
        search: `?model=balance&refYear=${headerStatus.refYear}&fromDate=${fromDate}&toDate=${toDate}&mode=${headerStatus.mode ? "COMPETENCE" : "ENTRY"}`
      });
      dispatch(getBalanceRead(
        headerStatus.refYear,
        fromDate,
        toDate,
        headerStatus.mode
      ));
    }
    if (modelConfig.id === "ledger") {
      const fromDate = headerStatus.fromDate ? headerStatus.fromDate.format().substring(0, 10) : "";
      const toDate = headerStatus.fromDate ? headerStatus.toDate.format().substring(0, 10) : "";
      navigate({
        pathname: "/reports",
        search: `?model=ledger&accountId=${headerStatus.accountId}&fromDate=${fromDate}&toDate=${toDate}&accountName=${headerStatus.accountName}`
      });
      dispatch(getEntriesRead(
        headerStatus.accountId,
        headerStatus.accountName.toLowerCase(),
        fromDate,
        toDate
      )).then(res => setOpened(false));
    }
  };

  const parseConfigItems = items => {
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];
    return items.map((item, index) => {
      if (item.type === "dropdown") {
        return (
          <VaporFormItem key={index} label={item.label}>
            <Select
              showSearch
              optionFilterProp="children"
              getPopupContainer={trigger => trigger.parentNode}
              value={headerStatus[item.id]}
              filterOption={(input, option) => {
                return option.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
              }}
              onSelect={value => {
                if (item.updateRangeDateId) {
                  setHeaderStatus([item.id, item.updateRangeDateId[0], item.updateRangeDateId[1]], [value, moment("01/01/" + value), moment("12/31/" + value)]);
                } else
                  setHeaderStatus(item.id, value);
              }}
            >
              {item.range
                ? renderRange(item.range.min, item.range.max)
                : renderValues(item.values)}
            </Select>
          </VaporFormItem>
        );
      }
      if (item.type === "checkbox") {
        return (
          <div
            key={index}
            className={
              "dbx-reports-header-checkbox " +
              (index < items.length - 1 ? "mb" : "")
            }
          >
            <Checkbox
              label={item.label}
              checked={headerStatus[item.id]}
              onChange={() => setHeaderStatus(item.id, !headerStatus[item.id])}
            ></Checkbox>
          </div>
        );
      }
      if (item.type === "rangedate") {
        return (
          <VaporFormItem key={index} label={item.label}>
            <VaporRangeDatePicker
              placeholder={["Data inizio", "Data fine"]}
              value={[headerStatus[item.id[0]], headerStatus[item.id[1]]]}
              suffixIconStyle={{ marginRight: "3px" }}
              onChange={e => {
                if (e && e.length !== 0) {
                  setHeaderStatus(item.id, e);
                } else {
                  setHeaderStatus(item.id, [null, null]);
                }
                if (item.updateDropdownDateId)
                  setHeaderStatus(item.updateDropdownDateId, undefined);

              }}
            />
          </VaporFormItem>
        );
      }
      if (item.type === "date") {
        return (
          <VaporFormItem key={index} label={item.label}>
            <VaporDatePicker
              format={dateFormatList}
              getPopupContainer={(trigger) => trigger.parentNode}
              value={
                headerStatus[item.id]
                  ? moment(headerStatus[item.id])
                  : undefined
              }
              onChange={value => setHeaderStatus(item.id, value)}
            />
          </VaporFormItem>
        );
      }
      if (item.type === "autocomplete") {
        const options = headerStatus[item.id[0]] ? headerStatus[item.id[0]].filter(i => i.label.toLowerCase().includes(headerStatus[item.id[2]]?.toLowerCase())) : [];
        return (
          <VaporFormItem key={index} label={item.label}>
            <AutoComplete
              options={options}
              value={headerStatus[item.id[2]]}
              onChange={e => {
                const optionsVisible = headerStatus[item.id[0]].filter(i => i.label.toLowerCase() === e.toLowerCase());
                const code = optionsVisible.length === 1 ? optionsVisible[0].code : "";
                setHeaderStatus([item.id[1], item.id[2]], [code, e]);
              }}
            >
            </AutoComplete>
          </VaporFormItem>);
      }
      if (item.type === "accountsList") {
        /** Se siamo in ricerca mostro solo l'indice 0 altrimenti entrambi */
        const headerValue = headerStatus[item.id[0]] && headerStatus[item.id[1]] ? headerStatus[item.id[0]] + " - " + headerStatus[item.id[1]] : headerStatus[item.id[1]];
        return (
          <VaporFormItem key={index} label={item.label}>
            <AutocompleteSelector
              overlayClassName="accounting-accounts-popover"
              popoverPlacement="bottom"
              isAccountingAccounts={true}
              singlePopover={true}
              placeholder={"Cerca conto contabile"}
              value={currentValue ? currentValue : headerValue}
              includeSystem={true}
              onlyConfirmed={true}
              onChange={(el => {
                if (el.title && el.code) {
                  setCurrentValue(null);
                  setHeaderStatus([item.id[0], item.id[1]], [el.code.replaceAll(" ", ""), el.title.replace(" ", "")]);
                } else {
                  setCurrentValue(null);
                  setHeaderStatus([item.id[0], item.id[1]], ["", el.title]);
                }
              })}
              onSearch={(val) => {
                setCurrentValue(val);
              }}
              vapor={true}
            />
          </VaporFormItem>
        );
      }
      if (item.type === "toggle") {
        return (
          <div key={index} style={{display: "flex", gap: "8px", alignItems: "center" }}>
            <Toggle
              checked={headerStatus[item.id]}
              onChange={value => setHeaderStatus(item.id, value)}
            />
            <div>{item.label}</div>
          </div>);
      }
      return null;
    });
  };

  return (
    <div className="dbx-reports-header-container">
      <VaporAccordion
        className={"report-header-accordion"}
        itemId={"report-header-accordion"}
        opened={opened}
        onChange={val => setOpened(val)}
        title="Imposta i filtri per visualizzare i report"
        description=""
      >
        <div className="dbx-reports-header">
          {modelConfig.header.rows.map((row, index) => {
            if (row.type === "row") {
              return (
                <div key={index} className="dbx-reports-header-firstrow">
                  {parseConfigItems(row.items)}
                </div>
              );
            }
            if (row.type === "col") {
              return parseConfigItems(row.items);
            }
            return null;
          })}
          <div className="dbx-reports-header-buttons">
            <Button kind="secondary" onClick={resetHeaderStatus}>
              Pulisci i filtri
            </Button>
            <Button kind="primary" onClick={getReport}>
              Cerca
            </Button>
          </div>
        </div>
      </VaporAccordion>
    </div>
  );
};
ReportCommonHeader.propTypes = {
  setSelectedSearch: PropTypes.func.isRequired,
  modelConfig: PropTypes.object.isRequired
};

ReportCommonHeader.defaultProps = {};

export default ReportCommonHeader;
